import { useMutation } from '@tanstack/react-query';
import type { EndWidgetChatResponse } from 'server';
import { appFetch } from './appFetch';

export const useEndChat = (chatId: string) => {
  return useMutation({
    mutationFn: async (): Promise<EndWidgetChatResponse> => {
      const response = await appFetch<EndWidgetChatResponse>(`/app/public/widget/chats/${chatId}/end`, {
        method: 'POST'
      });
      return response;
    }
  });
};
